@if (showNotification) {
  <div
    [ngClass]="{
      'grid-max-width grid-col-12 no-row-gap': isNewBrand(),
    }"
  >
    <fcom-notification
      [class.col-1-12]="isNewBrand()"
      [class.ms-xsmall-b]="isNewBrand()"
      [isClosable]="true"
      [layout]="isNewBrand() ? NotificationLayout.BLOCK : NotificationLayout.EDGE_TO_EDGE"
      [theme]="NotificationTheme.SUCCESS"
      (closeClick)="showNotification = false"
    >
      {{ 'newsletterSubscribedNotification' | finLocalization }}
    </fcom-notification>
  </div>
}
